import React from 'react'
import moment from 'moment-timezone'
import { Card } from 'react-bootstrap'

export default class NewsCard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <a href={this.props.story.link} target='_blank' rel="noreferrer">
        <Card className='mb-3'>
          { this.props.story.image ? <Card.Img variant='top' src={this.props.story.image} /> : '' }
          <Card.Body>
            <Card.Title>{this.props.story.title}</Card.Title>
            {this.props.story?.description ? <Card.Text>{this._transformHTMLEntities(this.props.story.description)}</Card.Text> : '' }
            <div className='float-end'><sub>{moment(this.props.story.pubDate).format('Do MMMM YYYY h:mm a')}</sub></div>
            <div style={{ fontWeight: 'bold' }}>{this.props.story.category}</div>
          </Card.Body>
        </Card>
      </a>
    )
  }

  _transformHTMLEntities (text) {
    const element = document.createElement('div')
    if (text && typeof text === 'string') {
      text = text.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '')
      text = text.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '')
      element.innerHTML = text
      text = element.textContent
      element.textContent = ''
    }

    return text
  }
}
